module.exports = __webpack_public_path__ + "static/media/6-rectangle-onhold.1ff7d526.svg";